
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.less'],
  standalone: true,
})
export class ErrorComponent implements OnInit {
  errorMessage = '';

  private _destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute) { }

  public ngOnInit(): void {
    this._setErrorMsgFromQueryParams();
  }

  private _setErrorMsgFromQueryParams(): void {
    this.route.queryParams.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
      params => { if (params) { this.errorMessage = params['error'] } }
    );
  }
}
